import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider }    from '@/contexts/AuthContext.jsx';
import { SocketProvider }  from '@/contexts/SocketContext.jsx';
import { VoiceProvider }   from '@/contexts/VoiceContext.jsx';
import { RoomProvider }    from '@/contexts/RoomContext.jsx';
import { FriendsProvider } from '@/contexts/FriendsContext.jsx';
import ProtectedRoute      from '@/components/layout/ProtectedRoute.jsx';
import ProfilePage         from '@/pages/ProfilePage.jsx';
import ErrorBoundary       from '@/components/layout/ErrorBoundary.jsx';
import LandingPage         from '@/pages/LandingPage.jsx';
import HomePage            from '@/pages/HomePage.jsx';
import JoinPage            from '@/pages/JoinPage.jsx';
import LoginPage           from '@/pages/LoginPage.jsx';
import AuthCallbackPage    from '@/pages/AuthCallbackPage.jsx';
import RoomPage            from '@/pages/RoomPage.jsx';
import MusicRoomPage       from '@/pages/MusicRoomPage.jsx';
import MusicPage           from '@/pages/MusicPage.jsx';
import PlaylistDetailPage  from '@/pages/PlaylistDetailPage.jsx';
import SpotifyCallbackPage from '@/pages/SpotifyCallbackPage.jsx';
import YouTubeCallbackPage from '@/pages/YouTubeCallbackPage.jsx';
import PlatformPage        from '@/pages/PlatformPage.jsx';
import HowToPage           from '@/pages/HowToPage.jsx';
import PrivacyPage         from '@/pages/PrivacyPage.jsx';
import FriendsPage         from '@/pages/FriendsPage.jsx';
import GamesPage           from '@/pages/GamesPage.jsx';
import GameRoomPage        from '@/pages/GameRoomPage.jsx';
import Ludo3DPage          from '@/pages/Ludo3DPage.jsx';
import AvatarClosetPage    from '@/pages/AvatarClosetPage.jsx';
import InventoryPage       from '@/pages/InventoryPage.jsx';
import VroidHubCallbackPage from '@/pages/VroidHubCallbackPage.jsx';
import InstallPrompt       from '@/components/pwa/InstallPrompt.jsx';

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <SocketProvider>
      <VoiceProvider>
      <FriendsProvider>
        <Routes>
          {/* Public */}
          <Route path="/"                   element={<LandingPage />} />
          <Route path="/join"               element={<JoinPage />} />
          <Route path="/join/:roomId"       element={<JoinPage />} />
          <Route path="/login"              element={<LoginPage />} />
          <Route path="/auth/callback"      element={<AuthCallbackPage />} />
          <Route path="/platform/:platformId" element={<PlatformPage />} />
          <Route path="/how-to"               element={<HowToPage />} />
          <Route path="/privacy"              element={<PrivacyPage />} />

          {/* Protected */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/friends" element={<FriendsPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/music/playlist/:playlistId" element={<PlaylistDetailPage />} />
            <Route path="/music/shared/:shareCode" element={<PlaylistDetailPage />} />
            <Route path="/auth/spotify/callback" element={<SpotifyCallbackPage />} />
            <Route path="/auth/youtube/callback" element={<YouTubeCallbackPage />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/ludo-3d" element={<Ludo3DPage />} />
            <Route path="/avatar-closet" element={<AvatarClosetPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/auth/vroid-hub/callback" element={<VroidHubCallbackPage />} />
            <Route
              path="/room/:roomId"
              element={
                <RoomProvider>
                  <RoomPage />
                </RoomProvider>
              }
            />
            <Route
              path="/music-room/:roomId"
              element={
                <RoomProvider>
                  <MusicRoomPage />
                </RoomProvider>
              }
            />
            <Route
              path="/game-room/:roomId"
              element={
                <RoomProvider>
                  <GameRoomPage />
                </RoomProvider>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <InstallPrompt />

        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background:  '#0e1118',
              color:       '#c8d6f0',
              border:      '1px solid #1e2433',
              fontFamily:  'DM Sans, sans-serif',
              fontSize:    '14px',
            },
            success: { iconTheme: { primary: '#f5a623', secondary: '#080a0f' } },
            error:   { iconTheme: { primary: '#ff4757', secondary: '#080a0f' } },
          }}
        />
      </FriendsProvider>
      </VoiceProvider>
      </SocketProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}